import React from 'react';
import i18n from '@i18next/i18n';
import { Feature } from '@tencent/workbench';
import BaseTopMenuFeature from '@framework/workbench/common/feature/base-top-menu-feature';
import { IAccessibilityManager } from '@src/slide/application/service/accessibility-manager/core/accessibility-manager.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IAccessibilityFeature } from '@src/framework/workbench/ui/accessibility/accessibility-interface';

@Feature()
export class AccessibilityFeature extends BaseTopMenuFeature implements IAccessibilityFeature {
    public constructor() {
        super();
        this.getAppService().viewableServiceLayer.accessibilityManager.promise();
    }

    public get AccessibilityToggle() {
        return AccessibilityToggle;
    }
}

const AccessibilityToggle: React.FC<{ a11yManager: IDynamicService<IAccessibilityManager> }> = (props) => {
    const [isA11yOn, setIsA11yOn] = React.useState(false);
    React.useEffect(() => {
        const loadA11yManager = async () => {
            const a11yManager = await props.a11yManager.promise();
            setIsA11yOn(a11yManager.isAccessibilityOn);
        };
        loadA11yManager();
    }, []);
    return <>
        {isA11yOn ? i18n.t('关闭无障碍读屏') : i18n.t('开启无障碍读屏')}
    </>;
};
